export function Animation(array, colors) {
  return { array: array, colors: colors };
}
